var _defs, _g, _g2, _g3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageComponent(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_104816",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #828282;\n      }\n\n      .st1 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        fill: none;\n        stroke: #707070;\n      }\n\n      .st3 {\n        fill: #838181;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_146226"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 0.5,
    y: 0.5,
    width: 97,
    height: 101,
    rx: 3.5,
    ry: 3.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Two",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.3,86h-1.2v-7.1h1.2v7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,80.7v.6c.4-.4.9-.6,1.6-.6s1.2.3,1.5.8c.4-.5.9-.8,1.6-.8s1,.2,1.3.5.4.8.4,1.4v3.5h-1.2v-3.4c0-.3,0-.6-.2-.7s-.4-.2-.7-.2-.5,0-.7.2c-.2.1-.3.3-.4.6v3.6s-1.2,0-1.2,0v-3.5c0-.6-.3-.9-1-.9s-.8.2-1,.6v3.8h-1.2v-5.3h1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,86c0-.1,0-.3-.1-.5-.4.4-.8.6-1.4.6s-1-.2-1.3-.5-.5-.7-.5-1.1.2-1,.6-1.3c.4-.3,1-.5,1.8-.5h.7v-.3c0-.3,0-.5-.2-.7-.2-.2-.4-.2-.7-.2s-.5,0-.7.2c-.2.1-.3.3-.3.5h-1.2c0-.3,0-.6.3-.8.2-.3.5-.5.8-.6s.7-.2,1.1-.2c.6,0,1.1.2,1.5.5.4.3.6.7.6,1.3v2.4c0,.5,0,.9.2,1.1h0c0,0-1.2,0-1.2,0ZM39.2,85.1c.2,0,.5,0,.7-.2s.4-.3.5-.5v-1h-.6c-.4,0-.8,0-1,.2s-.3.4-.3.6,0,.4.2.5c.2.1.4.2.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.6,83.3c0-.8.2-1.5.6-2,.4-.5.9-.7,1.5-.7s1.1.2,1.4.6v-.5h1.1v5.1c0,.7-.2,1.2-.6,1.6s-1,.6-1.7.6-.8,0-1.1-.2c-.4-.2-.7-.4-.8-.6l.6-.7c.4.4.8.6,1.3.6s.7-.1.9-.3c.2-.2.3-.5.3-.9v-.4c-.3.4-.8.6-1.4.6s-1.1-.2-1.5-.7-.6-1.2-.6-2ZM43.8,83.4c0,.5.1.9.3,1.3.2.3.5.5.9.5s.8-.2,1.1-.6v-2.3c-.2-.4-.6-.6-1.1-.6s-.7.2-.9.5-.3.8-.3,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.8,86.1c-.8,0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9h0c0-.7.1-1.1.3-1.6.2-.4.5-.7.9-1s.8-.3,1.2-.3c.7,0,1.3.2,1.7.7.4.5.6,1.1.6,1.9v.5h-3.5c0,.4.2.8.4,1s.6.4,1,.4,1-.2,1.3-.7l.6.6c-.2.3-.5.6-.8.7-.4.2-.8.3-1.2.3ZM50.6,81.6c-.3,0-.6.1-.8.3-.2.2-.3.5-.4,1h2.3c0-.5-.1-.8-.3-1-.2-.2-.4-.3-.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.9,83.7c0,.8-.4,1.3-.8,1.8-.5.4-1.1.6-1.9.6s-1.1-.1-1.5-.4c-.4-.3-.8-.7-1-1.1s-.4-1.1-.4-1.7v-.7c0-.7.1-1.3.4-1.8s.6-.9,1-1.2c.4-.3,1-.4,1.5-.4s1.4.2,1.9.6c.5.4.8,1,.8,1.8h-1.2c0-.5-.2-.9-.4-1.1-.2-.2-.6-.3-1.1-.3s-.9.2-1.2.6c-.3.4-.4,1-.4,1.7v.6c0,.8.1,1.4.4,1.8.3.4.7.6,1.2.6s.8-.1,1.1-.3.4-.6.5-1.1h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.2,86.1c-.8,0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.9h0c0-.7.1-1.1.3-1.6.2-.4.5-.7.9-1s.8-.3,1.2-.3c.7,0,1.3.2,1.7.7.4.5.6,1.1.6,1.9v.5h-3.5c0,.4.2.8.4,1,.3.3.6.4,1,.4s1-.2,1.3-.7l.6.6c-.2.3-.5.6-.8.7-.4.2-.8.3-1.2.3ZM65,81.6c-.3,0-.6.1-.8.3-.2.2-.3.5-.4,1h2.3c0-.5-.1-.8-.3-1-.2-.2-.4-.3-.8-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.5,86h-1.2v-7.5h1.2v7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72,86h-1.2v-7.5h1.2v7.5Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_104820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64443",
    className: "st3",
    d: "M71.2,60.7H26.2c-2.5,0-4.5-2-4.5-4.5v-31c0-2.5,2-4.5,4.5-4.5h45c2.5,0,4.5,2,4.5,4.5v31c0,2.5-2,4.5-4.5,4.5ZM26.2,21.9c-1.9,0-3.4,1.5-3.4,3.4v31c0,1.9,1.5,3.4,3.4,3.4h45c1.9,0,3.4-1.5,3.4-3.4v-31c0-1.9-1.5-3.4-3.4-3.4H26.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64444",
    className: "st3",
    d: "M22.8,57.1l-.8-.8,15.8-15.7c.8-.8,2-.8,2.8,0l9.9,9.9-.8.8-9.9-9.9c-.3-.3-.9-.3-1.3,0l-15.8,15.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64445",
    className: "st3",
    d: "M74.7,50.4l-15.6-16c-.2-.2-.4-.3-.6-.3h0c-.2,0-.5,0-.6.3l-12.1,12.1-.8-.8,12.1-12.1c.4-.4.9-.6,1.4-.6h0c.5,0,1,.2,1.4.6l15.6,16-.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64446",
    className: "st3",
    d: "M34.7,37.2c-3,0-5.5-2.5-5.5-5.5,0-3,2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5h0c0,3-2.5,5.5-5.5,5.5ZM34.7,27.4c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4,4.4-2,4.4-4.4c0-2.4-2-4.4-4.4-4.4h0Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageComponent);
export default __webpack_public_path__ + "static/media/imageComponent.f45e4fde32cb5d815be30ca0759f56ce.svg";
export { ForwardRef as ReactComponent };